import { Alert, Box, Grid } from '@mui/material';
import { FiagroResumeData } from 'src/types/operations/fiagro';

import OperationFIAGROResumeData from './OperationFIAGROResumeData';
import OperationFIAGROResumeGeneralData from './OperationFIAGROResumeGeneralData';
import OperationFIAGROResumeServiceProvider from './OperationFIAGROResumeServiceProvider';
import { FiagroCompetence } from '../components/FiagroCompetence';

export default function OperationFIAGROResume({
  data,
  error,
}: {
  data?: FiagroResumeData;
  error?: Error;
}) {
  if (!data && error) {
    return (
      <Box p={1}>
        <Alert severity="error" sx={{ fontWeight: 'bold' }}>
          Erro ao carregar dados de Fiagro: {(error as Error).message}
        </Alert>
      </Box>
    );
  }

  return (
    <Box p={1}>
      <Box px={1}>
        <FiagroCompetence competence={data?.general?.dataPlMaisRecenteFundo} />
      </Box>
      <Grid container>
        <Grid item xs={12} md={6}>
          <OperationFIAGROResumeGeneralData data={data?.general} />
        </Grid>
        <Grid item xs={12} md>
          <OperationFIAGROResumeServiceProvider data={data?.serviceProviders} />
        </Grid>
        <Box px={2}>
          <Grid item xs={12}>
            {data?.general?.categoriaAnexoNormativo && (
              <Alert severity="info" sx={{ width: '100%', fontWeight: 'bold' }}>
                Este FIAGRO também está sujeito ao Anexo Normativo II - Fundos
                de Investimento em Direitos Creditórios
              </Alert>
            )}
          </Grid>
        </Box>
        <Grid item xs={12}>
          <OperationFIAGROResumeData data={data?.data} />
        </Grid>
      </Grid>
    </Box>
  );
}
